import { ExpandLessRounded, ExpandMoreRounded } from '@material-ui/icons';

import type { SvgIconProps } from '@material-ui/core';

export function ExpandIcon(props: Props) {
  const { isExpanded = false, ...restProps } = props;
  const _ExpandIcon = isExpanded ? ExpandLessRounded : ExpandMoreRounded;
  return <_ExpandIcon fontSize='large' {...restProps} />;
}

interface Props extends SvgIconProps {
  isExpanded?: boolean;
}
